import {useTranslator} from '../../../lib/hooks/useTranslator.js';
import {CenteredContent} from '../../CenteredContent.js';
import {Header, Icon, Segment} from 'semantic-ui-react';
import HeaderSubHeader from 'semantic-ui-react/dist/commonjs/elements/Header/HeaderSubheader.js';
import React from 'react';
import {PageRefreshButton} from '../../Buttons/PageRefreshButton.js';
import {PseudoPageRefreshButton} from '../../Buttons/PseudoPageRefreshButton.js';

export const UnexpectedErrorMessage = ({refresh = false, padded}) => {
    const [t] = useTranslator('common');

    return <CenteredContent style={padded ? {padding: '1rem 2rem'} : null}>
        <Segment placeholder padded={'very'}>
            <Header as={'h2'} icon>
                <Icon color={'grey'} name={'bug'}/>
                {t('errors.unexpectedErrorHeader')}
                <HeaderSubHeader>
                    {t('errors.unexpectedErrorText')}
                </HeaderSubHeader>
            </Header>

            {refresh ?
                <PageRefreshButton/> :
                <PseudoPageRefreshButton/>}

        </Segment>
    </CenteredContent>;
};